/**
 * TypeScript representation of the WarehouseHandlingTier enum in String Array format
 * from the Java class com.amazon.warehouseHandlingTiers.WarehouseHandlingTier
 */
// Country-specific WHT arrays
export const IN_WHTS: string[] = [
  'std-in-10k', 'exp-in-grd-cod-eligible', 'same-in-cod-eligible',
  'std-in-50k', 'std-sns-in', 'std-in-buyback-cod-eligible',
  'exp-in-cod-eligible', 'std-in-buyback', 'exp-in',
  'same-in-am', 'exp-in-store', 'Default',
  'expd', 'same', 'std'
];

// Temporary 1:1 ship option -> WHT mapping for the JP GTRB/GSLA pilot (P513378303)
export const JP_WHTS: string[] = [
  'Default',
  'exp-jp-next', 'exp-jp-snl', 'exp-jp-timed', 'exp-jp-timed-pickup',
  'no-rush-delivery-jp', 'scheduled-delivery-hb-jp', 'scheduled-delivery-jp',
  'rush-lightning', 'rush-rapid', 'rush',
  'std-jp-consolidated', 'std-pri-jp-cvs', 'std-pri-jp-dom', 'std-pri-jp-dom2',
  'std-pri-jp-remote', 'std-pri-jp-snl', 'std-sns-jp-mainland', 'std-sns-jp-remote',
  'same-jp-c2d', 'same-jp-c2d-pickup'
];

export const DEFAULT_WHTS: string[] = [
  'Default', 'pa-expedited', 'expedited', 'rapid', 'rush', 'next',
  'lightning', 'expd-intl-us-latam2-ag', 'std-intl-us-asia3-ag'
];

// Default WHT constant (replaces WarehouseHandlingTier.Default)
export const DEFAULT_WHT = 'Default';

// Must match COUNTRY_TO_WHT in AFTGranularSLAModelService GSLAConstants
const COUNTRY_TO_WHTS: Record<string, string[]> = {
  IN: IN_WHTS,
  JP: JP_WHTS,
};

// All known WHTs across all countries
export const ALL_WHTS: string[] = Object.keys(COUNTRY_TO_WHTS).reduce(
  (all, country) => all.concat(COUNTRY_TO_WHTS[country].filter(t => all.indexOf(t) === -1)),
  DEFAULT_WHTS
);

import { getEnv, getRegion } from 'src/utils/Environment';
import { REGION } from 'src/core/config/APIConstants';

/**
 * Get valid WHTs based on warehouse ID and country code.
 * The NRT stack only serves the JP network, so every warehouse there (including DEFAULT) gets JP WHTs.
 * DEFAULT warehouse on EU returns all WHTs (serves both IN and non-IN FCs).
 */
export const getValidWHTsForCountry = (countryCode: string | null | undefined, warehouseId?: string): string[] => {
  const region = getRegion(window.location.host, getEnv());
  if (region === REGION.NRT) {
    return JP_WHTS;
  }
  if (warehouseId === 'DEFAULT' && region === REGION.EU) {
    return ALL_WHTS;
  }
  return (countryCode && COUNTRY_TO_WHTS.hasOwnProperty(countryCode)) ? COUNTRY_TO_WHTS[countryCode] : DEFAULT_WHTS;
};
